/* eslint import/no-webpack-loader-syntax: "off" */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(<App />, document.getElementById('newsroom-ui'));



// WEBPACK FOOTER //
// ./src/index.js